// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('[ScrollToTop] Changement de route détecté :', pathname);

    // Scroll en haut de la page
    window.scrollTo(0, 0);

  }, [pathname]);

  return null;
}

export default ScrollToTop;
